import {prefix} from "app/config/routes/tp/_cfg";

const o = ':orderId';

export const routeTPSettings = {
    'tp.account':             `${prefix}/account`,
    'tp.account.basicInfo':   `${prefix}/account/basic-info`,
    'tp.account.settings':    `${prefix}/account/settings`,
    'tp.account.recommendUs': `${prefix}/account/recommend-us`,
}